import { Configurator } from './configurator';
import i18n from '../../plugins/i18n';

export namespace Lang {
  export const LANG_COOKIE_NAME = 'lang';

  export enum LANGS {
    UK = 'en-GB',
    US = 'en-US',
    POLSKI = 'pl-PL',
    ITALIANO = 'it-IT',
    HUNGARIAN = 'hu-HU',
    SLOVENIAN = 'sl-SI',
    SPANISH = 'es-ES',
    DEUTSCH = 'de-DE',
    FRENCH = 'fr-FR',
  }

  export class LangItem {
    lang: string;
    flagPath: string;
    locale: LANGS;
    isAvailable: boolean;

    constructor(
      lang: string,
      flagPath: string,
      locale: LANGS,
      isAvailable: boolean,
    ) {
      this.lang = lang;
      this.flagPath = flagPath;
      this.locale = locale;
      this.isAvailable = isAvailable;
    }
  }

  export const langsList = (): LangItem[] => {
    const testTool: Configurator.State = Configurator.builder();
    const activateAllLocales =
      testTool?.localeModule.activateAllLocales ?? false;

    return [
      new LangItem('English', 'UK.svg', LANGS.UK, activateAllLocales || true),
      new LangItem(
        'Español',
        'Spanish.svg',
        LANGS.SPANISH,
        activateAllLocales || true,
      ),
      new LangItem(
        'Français',
        'French.svg',
        LANGS.FRENCH,
        activateAllLocales || true,
      ),
      new LangItem(
        'Italiano',
        'Italiano.svg',
        LANGS.ITALIANO,
        activateAllLocales || true,
      ),
      new LangItem(
        'Magyar',
        'Hungarian.svg',
        LANGS.HUNGARIAN,
        activateAllLocales || true,
      ),
      new LangItem(
        'Polski',
        'Polski.svg',
        LANGS.POLSKI,
        activateAllLocales || true,
      ),
      new LangItem(
        'Deutsch',
        'Deutsch.svg',
        LANGS.DEUTSCH,
        activateAllLocales || false,
      ),
    ];
  };

  export const DEFAULT_LANG = (): LangItem => {
    const $langsList = langsList();
    const UK = $langsList.find(it => it.locale === LANGS.UK);
    return UK ? UK : $langsList[0];
  };
}

export namespace Currency {
  export const CURRENCY_COOKIE_NAME = 'currency';

  export enum CURRENCIES {
    USD = 'USD',
    EUR = 'EUR',
    GBP = 'GBP',
    PLN = 'PLN',
    HUF = 'HUF',
  }

  export class CurrencyItem {
    currency: CURRENCIES;
    name: string;
    symbol: string;
    isAvailable: boolean;

    constructor(
      currency: CURRENCIES,
      name: string,
      symbol: string,
      isAvailable: boolean,
    ) {
      this.currency = currency;
      this.name = name;
      this.symbol = symbol;
      this.isAvailable = isAvailable;
    }
  }

  export const currenciesList = (): CurrencyItem[] => {
    const testTool: Configurator.State = Configurator.builder();
    const activateAllCurrencies =
      testTool?.currencyModule.activateAllCurrencies ?? false;

    return [
      new CurrencyItem(
        CURRENCIES.EUR,
        i18n.global.t('currencies.eur'),
        '€',
        activateAllCurrencies || true,
      ),
      new CurrencyItem(
        CURRENCIES.GBP,
        i18n.global.t('currencies.gbp'),
        '£',
        activateAllCurrencies || true,
      ),
      new CurrencyItem(
        CURRENCIES.USD,
        i18n.global.t('currencies.usd'),
        '$',
        activateAllCurrencies || true,
      ),
      new CurrencyItem(
        CURRENCIES.HUF,
        i18n.global.t('currencies.huf'),
        'Ft',
        activateAllCurrencies || true,
      ), //,
      // new CurrencyItem(CURRENCIES.PLN, i18n.global.t('currencies.pln'), 'zł', activateAllCurrencies || false)
    ];
  };

  export const DEFAULT_CURRENCY = (): CurrencyItem => {
    const $currenciesList = currenciesList();
    const USD = $currenciesList.find(it => it.currency === CURRENCIES.EUR);
    return USD ? USD : $currenciesList[0];
  };
}
